import { Module } from 'vuex';
import { IRootState } from '@/store';
import { IQuotePaymentTermCodeState } from './quote-payment-term-code.types';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IQuotePaymentTermCodeState = {
  version: 1,
  quotePaymentTermCodes: []
};

const namespaced = true;

export const quotePaymentTermCode: Module<
  IQuotePaymentTermCodeState,
  IRootState
> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
